import { render, staticRenderFns } from "./EmailHelpdeskIntegrationForm.vue?vue&type=template&id=5a924d19&"
import script from "./EmailHelpdeskIntegrationForm.vue?vue&type=script&lang=js&"
export * from "./EmailHelpdeskIntegrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports